import { inject, Injectable } from "@angular/core";
import { RequisitionGraphQlService } from "./requisition.graphql.service";
import { map } from "rxjs";
import { CANDIDATE_STATUS } from "app/modules/manage/workflow/task/workflow-task.constant";

@Injectable({ providedIn: 'root' })
export class RequisitionApi {
    #graphql: RequisitionGraphQlService = inject(RequisitionGraphQlService);

    // createRecommender<T extends Object>(objects: T) {
    //     return this.#graphql.insertRecommender(objects);
    // }

    updateRequisitionRecommender(aggId: string, data: Object) {
        // const where = { aggId: { _eq: aggId } }
        return this.#graphql.updateRequisitionRecommender(aggId, data)
    }

    // getRecommenderRequisition(aggId: string) {
    //     return this.#graphql.queryRequisitionRecommender(aggId)
    // }

    getParticipantReward(participantId: number) {
        return this.#graphql.queryParticipantReward(participantId)
    }

    queryRstbRequisitionForMatchingWhenApproveWhere(where: Object) {
        return this.#graphql.queryRstbRequisitionForMatchingWhenApproveWhere(where).pipe(
            map((res) => {
                return res?.map((item) => {
                    delete item?.__typename;
                    delete item?.job?.[0]?.__typename
                    return {
                        id: item?.id,
                        jobId: item?.job?.[0]?.jobId
                    }
                })
            })
        )
    }

    createRecruitRequisitionCandidate(objects: any, candidateAggId: string) {
        // const where = { id: { _eq: objects?.candidateId } };
        const _set = { status: CANDIDATE_STATUS.PROCESSING };
        return this.#graphql.createRecruitRequisitionCandidate(candidateAggId, _set, objects).pipe(
            map((r) => {
                delete r?.data?.returning?.[0]?.__typename
                return r?.data?.returning?.[0]
            })
        )
    }

    hrmQueryRstbRequisitionCandidateWhere(where: Object) {
        return this.#graphql.hrmQueryRstbRequisitionCandidateWhere(where)
    }

    hrmQueryRstbRequisitionCandidateForValidTransferWhere(requisitionId: any) {
        return this.#graphql.hrmQueryRstbRequisitionCandidateForValidTransferWhere(requisitionId)
    }

    queryCheckQuantityOfferDoneCandidateInRequisitionAndCandidateStatus(requisitionId: number, candidateId: number) {
        return this.#graphql.queryCheckQuantityOfferDoneCandidateInRequisitionAndCandidateStatus(requisitionId, candidateId)
    }

    // createCandidateRecommender(object: Object) {
    //     return this.#graphql.createCandidateRecommender(object)
    // }

    createRequisitionAttachment(object: Object) {
        return this.#graphql.createRequisitionAttachment(object);
    }

    updateRequisitionJob(aggId: String, object: Object) {
        return this.#graphql.updateRequisitionJob(aggId, object);
    }

    updateRequisitionByCode(code: String, object: Object) {
        return this.#graphql.updateRequisitionByCode(code, object);
    }

    getRerferenceCheck(where: Object) {
        return this.#graphql.getRerferenceCheck(where).pipe(
            map((response) => response?.data)
        )
    }

    getRequisitionCandidateAndRequestCode(candidateId: any) {
        return this.#graphql.getRequisitionCandidateAndRequestCode(candidateId).pipe(
            map((response) => response?.data || [])
        )
    }
}